import { toBaseLineItem } from "./base-line-item.js";
const toSolutionOrderLineItem = (lineItem, intl, options = {}) => {
  return {
    ...toBaseLineItem(lineItem, intl, options),
    type: "SOLUTION",
    isSubscription: lineItem.isSubscription,
    subscriptionDetails: lineItem.subscriptionDetails || void 0
  };
};
export {
  toSolutionOrderLineItem
};
//# sourceMappingURL=solution-line-item.js.map
